import React, { useState } from 'react';
import { expiredVNList, expiredVNRevert } from '../../../api-services';
import { useMutation, useQueryClient } from 'react-query';
import { Dropdown } from 'react-bootstrap';
import swal from 'sweetalert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEllipsisV,
} from '@fortawesome/free-solid-svg-icons';
import TableManager from '../../../components/TableManager';
import { createTable } from '@tanstack/react-table';
import Country from '../../../components/Country';
import moment from 'moment';

const table = createTable();

const DateFilterTypes = [
  { label: 'Today', value: 'Today' },
  { label: 'Yesterday', value: 'Yesterday' },
  { label: 'Last 7 Days', value: 'Last 7 Days' },
  { label: 'Last 30 Days', value: 'Last 30 Days' },
  { label: 'This Month', value: 'This Month' },
  { label: 'Last Month', value: 'Last Month' },
  { label: 'Custom', value: 'Custom' },
];


const numberFilterTypes = [
  { label: 'Less Than', value: 'less_than' },
  { label: 'Greater Than', value: 'greater_than' },
  { label: 'Is Equal To', value: 'is_equal' },
  { label: 'Is Not Equal To', value: 'is_not_equal' },
  { label: 'Less or Equal to', value: 'less_or_equal' },
  { label: 'Greater or Equal to', value: 'greater_or_equal' },
];

const initialValues = {
  filter: [
    {
      account_number: '',
      a_filter_type: '',
      placeholder: 'Enter MSISDN...',
      type: 'number',
      shouldFilterOptionDisabled: false,
      filterOptions: numberFilterTypes,
      label: 'MSISDN',
    },
    {
      did_number: '',
      a_filter_type: '',
      placeholder: 'Enter Did Number...',
      type: 'text',
      shouldFilterOptionDisabled: false,
      filterOptions: numberFilterTypes,
      label: 'Did Number',
    },


    {
      date: {
        from: '',
        to: '',
      },
      a_filter_type: '',
      placeholder: 'Custom Date Range...',
      type: 'date',
      shouldFilterOptionDisabled: false,
      filterOptions: DateFilterTypes,
      selectOptions: [],
      label: 'Date',
    },
  ],
};

const ExpiredVN = () => {
  const queryClient = useQueryClient();
  const [filters, setFilters] = useState([]);
  const [openFilter, setOpenFilter] = useState(false);

  const { mutate: mutateExpiredVNRevert } = useMutation(
    'revert-expired-vn',
    expiredVNRevert,
    {
      onSuccess: (data) => {
        swal({
          text: data?.data?.message ?? 'Success!',
          icon: 'success',
          type: 'success',
          timer: 2000,
        }).then(() => {
          queryClient.invalidateQueries('expired-vn-list');
        });
      },
      onError: (error) => {
        swal({
          title: error?.response?.data?.message || 'Something went wrong!',
          type: 'danger',
          icon: 'error',
        });
      },
    },
  );

  const handleExpiredVNRevert = (val) => {
    swal({
      text: 'Are you sure you want to revert this Expired VN?',
      buttons: true,
      icon: 'warning',
    }).then((willDelete) => {
      if (willDelete) {
        try {
          let payload = {
            id: val?.didID,
          };
          mutateExpiredVNRevert(payload);
        } catch (error) {
          console.error(error);
        }
      }
    });
  };





  const columns = [
    table.createDataColumn('expired_at', {
      id: 'expired_at',
      header: 'Expiration On',
      cell: (props) => {
        const date = props.getValue();
        return date ? moment(date).format('YYYY-MM-DD ') : '---'
      },
      isSortable: true,
    }),
    table.createDataColumn('expired_at', {
      id: 'expired_at',
      header: 'MSISDN',
      cell: (props) => {
        const data = props?.row?.original?.customer
        return <span>{data?.msisdn}</span>
      }
    }),

    table.createDataColumn('did_number', {
      id: 'did_number',
      header: 'DID Number',
      textAlign: 'left',
    }),
    table.createDataColumn('did_status', {
      id: 'did_status',
      header: 'Status',
      cell: () => {
        return <span>Expired</span>
      },
    }),
    table.createDataColumn('created_at', {
      id: 'created_at',
      header: 'Country',
      textAlign: 'left',
      cell: () => <Country isoCode={'FR'} />,
    }),
    table.createDisplayColumn({
      id: 'action',
      header: 'Action',
      cell: (props) => (
        <span>
          <Dropdown className="dropdown_dot mx-auto">
            <Dropdown.Toggle
              id="dropdown-basic"
              className="btn-light-blue btn-action "
            >
              <FontAwesomeIcon icon={faEllipsisV} />
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item
                href={void 0}
                onClick={() => handleExpiredVNRevert(props.row.original)}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-corner-down-left"><polyline points="9 10 4 15 9 20" /><path d="M20 4v7a4 4 0 0 1-4 4H4" /></svg>
                Send To Pool
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </span>
      ),
    }),
  ];

  return (
    <>
      <TableManager
        table={table}
        columns={columns}
        filter={filters}
        fetcherKey="expired-vn-list"
        fetcherFn={expiredVNList}
        title="Expired French VN"
        shouldFilter={true}
        openFilter={openFilter}
        setOpenFilter={setOpenFilter}
        initialValues={initialValues}
        setFilters={setFilters}
        filters={filters}
      />
    </>
  );
};

export default ExpiredVN;
